import classNames from 'classnames';
import {CloseButton} from './CloseButton';

export const ModalHeader = ({
  title,
  closeModal,
}: {
  title: string;
  closeModal: () => void;
}) => {
  return (
    <div
      className={classNames(
        'flex',
        'flex-row',
        'content-between',
        'px-6',
        'py-4',
      )}
    >
      <h2
        className={classNames('flex-1', 'text-xl', 'font-light', 'leading-10')}
      >
        {title}
      </h2>
      <CloseButton onClick={closeModal} className="cursor-pointer" />
    </div>
  );
};
